import { Component } from '@angular/core';

import { HelpWidgetService } from 'src/app/app-common/services/help-widget.service';

@Component({
  selector: 'help-widget-button',
  templateUrl: './help-widget-button.component.html',
  styleUrls: ['./help-widget-button.component.scss'],
  standalone: false,
})
export class HelpWidgetButtonComponent {
  constructor(public helpWidgetService: HelpWidgetService) {}
}
